import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { NavBar, Footer } from "../../components"
import configuration from "../../../package.json"

export const Sections = (props) => {
  const params = useParams()
  const {homepage} = configuration;
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [title, setTitle] = useState("")
  const [navigationStack, setNavigationStack] = useState([]) // Track navigation history
  
  useEffect(() => {
    if (location.state) {
      setList(location.state.sections)
      setTitle(location.state.title)
      setNavigationStack([]) // Reset navigation stack
    } else {
      navigate(`${homepage}`)
    }
  }, [])

  // Handle section navigation
  const handleSectionClick = (section) => {
    if (section.kind === 'sections' && section.sections && section.sections.length > 0) {
      // If section has children, navigate to children
      setNavigationStack(prev => [...prev, { list, title }]) // Save current state
      setList(section.sections)
      setTitle(section.title)
    }
    // If no children or kind is not 'sections', the Link will handle navigation
  }

  // Handle back navigation
  const handleBackNavigation = () => {
    if (navigationStack.length > 0) {
      const previousState = navigationStack[navigationStack.length - 1]
      setNavigationStack(prev => prev.slice(0, -1))
      setList(previousState.list)
      setTitle(previousState.title)
      return true // Indicate we handled the navigation
    }
    return false // Let default back behavior handle it
  }

  const SectionRender = ({ 
    index, 
    title, 
    kind, 
    description, 
    items, 
    header, 
    lettersort, 
    sections ,
    sound,
    srt,
    images
  }) => {
    const hasChildren = kind === 'sections' && sections && sections.length > 0;
    
    return (
      <div className={`flex w-full flex-col justify-between shadow-lg ${(title.sound && title.sound !== "") ? 'cursor-pointer' : ''}`}>
        <div className="flex flex-row">
          <div className="flex w-full flex-row justify-start items-stretch gap-1">
            <div className='bg-gray-600 text-white w-10 text-center rounded-l-lg shrink-0 self-stretch relative'>
              <div className='absolute w-full h-full top-0 bottom-0 m-auto flex items-center justify-center'>{index}</div>
            </div>
            <div className='bg-white text-black w-full h-fit rounded-r-lg flex flex-row gap-1 justify-between'>
              {hasChildren ? (
                // If has children, use div with click handler
                <div
                  onClick={() => handleSectionClick({ title, kind, sections })}
                  className="flex flex-row flex-wrap justify-between w-full cursor-pointer hover:bg-gray-50 transition-colors py-2"
                >
                  <div className="flex-auto px-2">
                    <div>{title.phrase}</div>
                    {title.subtitle && (
                      <div className="text-sm text-gray-500">{title.subtitle}</div>
                    )}
                  </div>
                  <div className="flex-auto px-2 text-right">{title.ar}</div>
                  <div className="px-2 flex items-center text-gray-500">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              ) : (
                // If no children, use Link for navigation
                <Link
                  to={`/dict/${params.stage}/${params.subject}/${params.grade}/${params.year}/${params.version}/${kind}`}
                  hash={title}
                  state={{ title, kind, items, header, lettersort , sound, srt ,images }}
                  className="flex flex-row flex-wrap justify-between w-full hover:bg-gray-50 transition-colors py-2"
                >
                  <div className="flex-auto px-2">
                    <div>{title.phrase}</div>
                    {title.subtitle && (
                      <div className="text-sm text-gray-500">{title.subtitle}</div>
                    )}
                  </div>
                  <div className="flex-auto px-2 text-right">{title.ar}</div>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="flex w-full max-w-screen h-fit min-h-screen p-0 m-0 flex-col gap-2 overflow-hidden md:max-w-[875px] md:m-auto">
      <NavBar 
        title={typeof title === 'string' ? title : title.phrase} 
        backto={navigationStack.length > 0 ? handleBackNavigation : -1}  
        search={true} 
      />
      <div className="w-full flex p-2 top-20 relative">
        <div className="flex w-full flex-col gap-2 justify-start">
          {
            list.map((item, index) => 
              <SectionRender 
                key={index} 
                index={index + 1} 
                {...item} 
              />
            )
          }
        </div>
      </div>
      <div className="h-24" />
      <Footer />
    </div>
  );
}